import React from 'react';
import PropTypes from 'prop-types';

import { Communicators } from 'presentation/components/lib/communicators';
import Message from 'presentation/components/Message';
import MessageStack from 'presentation/components/MessageStack';

import overrideStyle from 'lib/overrideStyle';

export default function PreIdentifiedUserWelcomeMessage(props) {
  const preIdentifiedUserWelcomeMessage = [
    <Message content={props.content} sender={Communicators.AGENT} key="preIdentifiedUserWelcomeMessage" />,
  ];

  return (
    <Wrapper>
      <MessageStack messages={preIdentifiedUserWelcomeMessage} sender={Communicators.AGENT} />
    </Wrapper>
  );
}

PreIdentifiedUserWelcomeMessage.propTypes = {
  content: PropTypes.string.isRequired,
};

const Wrapper = overrideStyle('div')`
  font-family: ${p => p.theme.fontLibrary.secondary};
`;
